import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../redux/slices/authSlice";
import { FaBars, FaUser, FaSignOutAlt, FaCaretRight, FaCog } from "react-icons/fa";
import profileService from "../../services/profileService";
import NotificationBell from "./NotificationBell";
import { getUserRoleTitle, isAdmin, ROLES } from "../../utils/permissionManager";

const Header = ({ onToggleSidebar, sidebarOpen }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useSelector((state) => state.auth);
  const [me, setMe] = useState(null);

  useEffect(() => {
    // Debug: verify user and image url present
    console.log("Header user:", user);
    console.log("Header image_url:", user?.image_url);
    (async () => {
      try {
        const res = await profileService.getMe();
        if (res) setMe(res);
      } catch (e) {
        // ignore
      }
    })();
  }, [user]);

  const handleLogout = () => {
    dispatch(logout());
    navigate("/bookedu/login");
  };

  const getPageTitle = () => {
    const path = location.pathname;

    if (path === "/") return "Admin Dashboard";
    if (path.startsWith("/admin/vendors")) return "Vendors";
    if (path.startsWith("/category")) return "Categories";
    if (path.startsWith("/sub-category")) return "SubCategories";
    if (path.startsWith("/product")) return "Products";
    if (path.startsWith("/orders")) return "Orders";

    return "Dashboard";
  };

  const getDashboardTitle = () => {
    if (!user) return "Dashboard";
    return getUserRoleTitle(user);
  };

  return (
    <header className="koyo-header">
      <div className="koyo-header-container">
        {/* Left side - Sidebar toggle button and title */}
        <div className="koyo-header-left">
          <button className="sidebar-toggle-btn" onClick={onToggleSidebar} title={sidebarOpen ? "Hide Sidebar" : "Show Sidebar"}>
            {sidebarOpen ? <FaBars /> : <FaCaretRight />}
          </button>
          <div
            className="user-info"
            style={{ display: "flex", alignItems: "center", gap: 8 }}
          >
            <div
              style={{
                width: 24,
                height: 24,
                borderRadius: "50%",
                overflow: "hidden",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#eef5e6",
              }}
            >
              <img
                src={
                  me?.image_url && me.image_url.trim() !== ""
                    ? me.image_url
                    : user?.image_url && user.image_url.trim() !== ""
                    ? user.image_url
                    : process.env.PUBLIC_URL + "/not-img-found.png"
                }
                alt="avatar"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = process.env.PUBLIC_URL + "/not-img-found.png";
                }}
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            </div>
            <span className="koyo-user-greeting">
              Hello, {user?.first_name || ""}
            </span>
            <span
              style={{
                fontSize: "11px",
                fontWeight: "600",
                backgroundColor: "#e3f2fd",
                color: "#1565c0",
                padding: "2px 8px",
                borderRadius: "12px",
                border: "1px solid #bbdefb",
                marginLeft: "4px",
                display: "inline-block",
                textTransform: "capitalize",
              }}
            >
              {getUserRoleTitle(user)}
            </span>
          </div>
          <div className="header-title">
            <div className="user-info">
              <p className="page-subtitle">{getDashboardTitle()}</p>
            </div>
          </div>
        </div>

        {/* Right side - User info and actions */}
        <div className="koyo-header-right">
          {user ? (
            <div className="koyo-user-nav">
              {isAdmin(user) && (
                <Link to="/admin/settings" className="koyo-logout-btn" title="Settings" style={{ padding: "0.5rem" }}>
                  <FaCog />
                </Link>
              )}
              <NotificationBell />
              <button onClick={handleLogout} className="koyo-logout-btn">
                <FaSignOutAlt />
                <span>Logout</span>
              </button>
            </div>
          ) : (
            <div className="koyo-auth-links">
              <Link to="/login" className="koyo-header-link">
                Login
              </Link>
              <Link to="/register" className="koyo-header-link">
                Register
              </Link>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
